import { Fragment, useEffect, useState } from 'react';
import CustomSelect from '../../custom_components/CustomSelect';
import './Panel.css'

interface Props {
    panels: any;
    monitor_view_type: string;
    get_updated_url: (url: string) => void
}

const Beacon: React.FC<Props> = ({ panels, monitor_view_type, get_updated_url }) => {

    const [beaconType, setBeaconType] = useState<
        {
            label: string,
            value: string
        } | null
    >(null);

    const [beaconTypes, setBeaconTypes] = useState<{
        label: string,
        value: string
    }[]>([]);

    useEffect(() => {
        if (panels && Object.keys(panels)?.length > 0) {
            let types: {
                label: string,
                value: string
            }[] = []
            let selected_type: string = ''
            Object.keys(panels)?.map((type) => {
                types.push({
                    label: type,
                    value: type
                })
                selected_type = selected_type === '' ? type : selected_type
            })
            setBeaconType({
                label: selected_type,
                value: selected_type
            })

            setBeaconTypes(types)
        }
    }, [panels])

    useEffect(() => {
        const handleBlur = () => {
            setTimeout(() => window.focus(), 0);
        };

        window.addEventListener('blur', handleBlur);

        return () => {
            window.removeEventListener('blur', handleBlur);
        };
    }, []);

    return (
        <Fragment>

            <div className="monitor__container__body__header">

                <div className='d-flex align-items-center justify-content-between'>
                    <CustomSelect disabled_search={true} options={beaconTypes} value={beaconType} onChange={(data) => { setBeaconType(data) }} className="header__select__container" />
                </div>
            </div>

            <div className={`${monitor_view_type === 'Grid' ? 'monitor__grid__view' : 'monitor__list__view'}`}>
                {beaconType && panels?.[beaconType?.value]?.length > 0 && (
                    panels?.[beaconType?.value]?.map((panel: { panel_name: string; url: string }) => (
                        <div className='monitor__item__container' key={panel?.panel_name}>
                            {panel?.url && (
                                <iframe src={`${get_updated_url(panel?.url)}`} className='panel__frame' />
                            )}
                        </div>
                    ))
                )}
            </div>

        </Fragment>
    )
}

export default Beacon

